<template>
  <div class="dashboard">
    <!-- v-if="this.$store.state.user.user" -->
    <v-container>
      <v-row>
        <v-col cols="12" md="12" v-for="item in items" :key="item.nombre">
          <v-card class="mx-auto" outlined>
            <v-list-item class="pa-5">
              <v-list-item-avatar>
                <v-icon class="secondary lighten-1" dark>
                   mdi-calendar-range
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-left headline mb-1">
                  {{ item }}
                </v-list-item-title>
              </v-list-item-content>


                <span class="primary--text headline font-weight-bold">{{
                  item.items
                }}</span>


<v-card-actions>
              <v-spacer></v-spacer>
              
	<v-btn text right color="secondary" :to="`/contracts/${item}`">
                ver contratos
              </v-btn>
          
            </v-card-actions>
            
            </v-list-item>

            

            
          </v-card>
        </v-col>
      </v-row>
      
      <!-- Button active dialog / create record-->
    <v-btn
      class="mx-2"
      fab
      dark
      bottom
      fixed
      right
      color="secondary"
      href="/contracts/create"
      v-if="role == 'ADMINISTRATOR'"
    >
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>
    </v-container>
    
    
  </div>
</template>

<script>
/* import { SET_ALERT } from "@/store/alert"; */

import { SET_CONTRACTS_YEARS } from "@/store/contract/years";


export default {
  name: "Areas",
  
  filters: {

  },
  data: () => ({
    search: "",
    items: {},

    pagination: {
      current: 0,
      total: 0,
    },
    validForm: true,

    
  }),
  computed: {
    role() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.role
        : "";
    },

  },
  created() {
    this.$store.dispatch("getContractYears");
    console.log(this.$store.state);
    this.$store.subscribe((mutation) => {
      if (mutation.type === SET_CONTRACTS_YEARS) {
      this.items = this.$store.state.contract_years.years;
      
      console.log(this.items)
       
      }
    });
  },

};
</script>
<style scoped>
.user {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
